var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('com-equ-search',{attrs:{"typeOfView":"partner"},on:{"search":_vm.handleSearch}}),_c('com-equ-list',{ref:"table",attrs:{"default-params":_vm.defaultParams,"type-of-view":"partner"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }